<template>
  <div class="footerbox" ref="f">
    <div class="mddw" id="f"></div>
    <div class="footerboxTop">
      <div class="list1">
        <p class="p1">联系我们</p>
        <div class="xian"></div>
        <p class="p2">服务热线</p>
        <p class="p3">0571-87357305</p>
        <p class="p2">公司邮箱</p>
        <p class="p3">zjax@ansuw.com</p>
      </div>
      <div class="list2">
        <p class="p1">产品服务</p>
        <div class="xian"></div>
        <p class="p1" style="line-height: 45px;margin: 0;">软件产品</p>
        <div style="display: flex;flex-wrap: wrap;">
          <a href="http://www.ax168.com/system?activeIndex=0">食品追溯系统</a>
          <a href="http://www.ax168.com/system?activeIndex=1">食品检测系统</a>
          <a href="http://www.ax168.com/system?activeIndex=2">市场运营系统</a>
          <a href="http://www.ax168.com/system?activeIndex=3">商家管理系统</a>
          <a href="http://www.ax168.com/system?activeIndex=4">会员营销系统</a>
          <a href="http://www.ax168.com/system?activeIndex=5">网上菜场系统</a>
          <a href="http://www.ax168.com/system?activeIndex=6">市场招商系统</a>
          <a href="http://www.ax168.com/system?activeIndex=7">电子结算系统</a>
          <a href="http://www.ax168.com/system?activeIndex=8">智能巡查系统</a>
          <a href="http://www.ax168.com/system?activeIndex=9">数据展示系统</a>
          <a href="http://www.ax168.com/system?activeIndex=10">智慧农场系统</a>
          <a href="http://www.ax168.com/system?activeIndex=11">智慧禽畜系统</a>
          <a href="http://www.ax168.com/system?activeIndex=12">智慧水产系统</a>
        </div>
        <p class="p1" style="line-height: 45px;margin: 0;">硬件产品</p>
        <div style="display: flex;flex-wrap: wrap;">
          <a>智慧农贸追溯电子秤</a>
          <a>商户信用公示屏</a>
          <a>放心农贸触摸一体机</a>
          <a>数据大屏</a>
        </div>
      </div>
      <div class="list3">
        <p class="p1">关于我们</p>
        <div class="xian"></div>
        <p class="p2">
          <a href="http://www.ax168.com/about/#a">企业简介</a>
        </p>
        <p class="p2">
          <a href="http://www.ax168.com/about/#b">企业优势</a>
        </p>
        <p class="p2">
          <a href="http://www.ax168.com/about/#c">资质荣誉</a>
        </p>
        <p class="p2">
          <a href="http://www.ax168.com/about/#d">企业特色</a>
        </p>
      </div>
    </div>
    <div class="footerboxC">
      <div class="xian"></div>
      <div class="textList">
        <p>解决方案</p>
        <p>
          <a href="http://www.ax168.com/publicity">智慧农贸解决方案</a>
        </p>
        <p>
          <a href="http://www.ax168.com/ygst">阳光厨房解决方案</a>
        </p>
        <p>
          <a href="http://www.ax168.com/zycpzs">重要产品追溯解决方案</a>
        </p>
      </div>
      <div class="xian"></div>
    </div>
    <div class="footerboxb">
      <p>地址： 浙江省杭州市西湖区西园八路11号一期D座506-507</p>
      <p style="cursor: pointer" @click="handNavGx">{{ICP_text}}</p>
      <p>公安部备案号：33010602001517</p>
    </div>
  </div>
</template>


<script>
export default {
  data(){
    return {
      ICP_text:'浙ICP备15019864号-1',
      ICP:{
        "http://localhost:8081":"测试",
        "http://www.ax168.com":"浙ICP备15019864号-4",
        "http://www.anxuan360.com":"浙ICP备15019864号-1",
        "http://www.axnm168.com":"浙ICP备15019864号-5",
        "http://www.aswnm.com":"浙ICP备15019864号-7",
        "http://www.axny168.com":"浙ICP备15019864号-6"
      },
    }
  },
  created: function() {
    let keys = Object.keys(this.ICP)
    let findIndex=  keys.findIndex(key=>{
       return  key.includes(window.location.host)
    })
    this.ICP_text =findIndex!=-1? this.ICP[keys[findIndex]]:this.ICP_text
    // this.$emit("footer", false);
    // this.$emit("footer1", false);
    // this.$emit("footer2", true);
  },
  methods:{
    handNavGx(){
      window.open("https://beian.miit.gov.cn", '_blank')
    }
  }
};
</script>

<style scoped="scoped">
@import url("../../css/retrospect.css");
@import url("../../css/home.css");
</style>



// WEBPACK FOOTER //
// src/page/newHomePage/footer.vue